import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import withRouter from 'react-router/withRouter';
import Sticky from 'react-stickynode';
import matchMediaDesktop from '../../../../../utils/client_util';
import loadData from './innovation_by_design_page_state_manager';

import loadable from '@loadable/component';
import clsx from 'clsx';
import { UserConsumer } from '../../../../components/context/userContext';
import PremiumPaywall from '../../../../components/PremiumPaywall/PremiumPaywall';

const NotFound = loadable(() =>
  import('../../../../components/not_found_component/not_found_component')
);
const LoadingSpinner = loadable(() =>
  import('../../../../components/loading_spinner/loading_spinner')
);
const AdContainer = loadable(() =>
  import('../../../../components/ad/AdContainer')
);
const Social = loadable(() => import('../../../../components/social/social'));
const AllFeed = loadable(() =>
  import('../../../../components/all_feed/all_feed')
);
const RankedCompany = loadable(() => import('../../../../components/ranked'), {
  resolveComponent: components => components.RankedCompany
});
const RankedIBDMenu = loadable(() => import('../../../../components/ranked'), {
  resolveComponent: components => components.RankedIBDMenu
});

class InnovationByDesign extends Component {
  static loadData(store) {
    return loadData(store);
  }

  constructor(props) {
    super(props);

    this.state = {
      activeCompaniesKey: 'a'
    };
    // This page is being used to render all year category data. The route does not use a parameter to set the year so the year
    // needs to be set manually for 2018. This page will not be used for 2019 so 2018 is an okay default value
    this.year = get(this.props, 'match.params.year', '2018');
    this.isDesktop = false;
    this.companies = null;
    this.desktopCompanyNav = null;
  }

  componentDidMount() {
    if (canUseDOM) {
      window.scrollTo(0, 0);
    }

    this.isDesktop = matchMediaDesktop('64em');
  }

  getCompanies() {
    if (this.companies) {
      return this.companies;
    }

    const data = this.getCategories();
    const filterCheck = [];
    const companies = [];
    /* eslint-disable */
    data.forEach(category =>
      Object.keys(category.products).forEach(key => {
        category.products[key].map(rank => {
          JSON.parse(rank.product_creators || '[]').forEach(company => {
            if (filterCheck.indexOf(company.url) === -1) {
              filterCheck.push(company.url);
              companies.push(company);
            }
          });
        });
      })
    );
    /* eslint-enable */

    this.companies = companies;

    return this.companies;
  }

  getDesktopCompanyList() {
    if (this.desktopCompanyNav) return this.desktopCompanyNav;

    const companyMap = {};
    const groupLookupMap = {
      d: 'd-f',
      e: 'd-f',
      f: 'd-f',
      g: 'g-h',
      h: 'g-h',
      i: 'i-k',
      j: 'i-k',
      k: 'i-k',
      n: 'n-o',
      o: 'n-o',
      p: 'p-r',
      q: 'p-r',
      r: 'p-r',
      t: 't-v',
      u: 't-v',
      v: 't-v',
      w: 'w-#',
      x: 'w-#',
      y: 'w-#',
      z: 'w-#'
    };
    this.getCompanies().forEach(company => {
      if (company) {
        const key = company.url.slice(0, 1);
        const groupKey = groupLookupMap[key];
        let k = groupKey || key;

        if (+key) {
          k = 'w-#';
        }

        if (companyMap[k]) {
          companyMap[k].push(company);
        } else {
          companyMap[k] = [company];
        }
      }
    });

    const orderedCompanyMap = {};
    Object.keys(companyMap)
      .sort()
      .forEach(key => {
        orderedCompanyMap[key] = companyMap[key];
      });

    this.desktopCompanyNav = orderedCompanyMap;

    return orderedCompanyMap;
  }

  getFilteredCompanies(companySlug) {
    const data = { products: { winners: [], finalists: [], mentions: [] } };

    /* eslint-disable */
    this.getCategories().forEach(category =>
      Object.keys(category.products).forEach(key => {
        category.products[key].map(rank => {
          const isOwner = JSON.parse(rank.product_creators || '[]').filter(
            company => {
              const isCompany = company.url === companySlug;
              if (isCompany && !data.category_name) {
                data.category_name = company.name;
              }
              return isCompany;
            }
          ).length;
          if (isOwner) {
            data.products[key].push(
              Object.assign(
                {},
                {
                  category_name: category.category_name
                },
                rank
              )
            );
          }
        });
      })
    );
    /* eslint-enable */

    return [data];
  }

  getCategories(param) {
    const data = get(this.props, 'innovationByDesign', []);
    if (param) {
      return data.filter(item => item.url === param);
    }
    const firstItem = 'design-company-of-the-year';
    return [
      ...data.filter(item => item.url === firstItem),
      ...data.filter(item => item.url !== firstItem)
    ];
  }

  getRankData(category, key) {
    return get(category, key, []);
  }

  getAllWinners() {
    const winners = [];

    this.getCategories().forEach(category =>
      this.getRankData(category.products, 'winners').forEach(company =>
        winners.push(company)
      )
    );

    return winners;
  }

  setActiveCompaniesKey(key) {
    this.setState({
      activeCompaniesKey: key
    });
  }

  renderNav() {
    const { activeCompaniesKey } = this.state;
    const activeCompanies = get(
      this.getDesktopCompanyList(),
      activeCompaniesKey,
      []
    );
    const emptySlots = 26 - get(activeCompanies, 'length', 0);
    return (
      <Sticky top={100} bottomBoundary="#ranked-nav" enabled={this.isDesktop}>
        <Social
          empty={false}
          enableSticky={false}
          modifier="ranked"
          uri={`https://www.fastcompany.com/innovation-by-design ${this.year}`}
          subject={`Innovation by Design Awards ${this.year}`}
          text={encodeURIComponent(
            `It’s official: the ${
              this.year
            } @FastCompany Innovation by Design winners might be the most impressive, inspiring group yet. See the full list of #FCDesignAwards honorees here:`
          )}
        />
        <UserConsumer>
          {({ hasPaywallAccess }) => {
            if (!hasPaywallAccess()) {
              return null;
            }

            return (
              <>
                <div className="ranked-list ranked-list--ibd ranked-list--slim">
                  <a href={`/innovation-by-design/${this.year}`}>See Winners</a>
                </div>
                <div className="ranked-list ranked-list--ibd ranked-list--slim ranked-list--extend">
                  <span>See Categories</span>
                  <div className="ranked-list__panel ranked-list__panel--ibd">
                    <ul>
                      {this.getCategories().map(category => (
                        <li>
                          <a
                            href={`/innovation-by-design/${
                              this.year
                            }/category/${category.url}`}
                          >
                            {category.category_name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="ranked-list ranked-list--ibd ranked-list--slim">
                  <span>See Companies</span>
                  <div className="ranked-list__panel ranked-list__panel--ibd">
                    <div className="ranked-list__filter">
                      {Object.keys(this.getDesktopCompanyList()).map(key => (
                        <div
                          className={key === activeCompaniesKey ? 'active' : ''}
                          key={key}
                          onClick={() => this.setActiveCompaniesKey(key)}
                        >
                          {key}
                        </div>
                      ))}
                    </div>
                    <ul>
                      {orderBy(activeCompanies, 'name', 'asc').map(company => (
                        <li>
                          <a
                            href={`/innovation-by-design/${this.year}/company/${
                              company.url
                            }`}
                          >
                            {company.name}
                          </a>
                        </li>
                      ))}
                      {emptySlots > 0 &&
                        [...Array(emptySlots)].map((e, i) => (
                          <li key={`empty-${i}`} />
                        ))}
                    </ul>
                  </div>
                </div>
              </>
            );
          }}
        </UserConsumer>
      </Sticky>
    );
  }

  renderHeader(data) {
    const { category, company } = get(this.props, 'match.params', {});

    if ((category || company) && data) {
      return (
        <header className="ranked__header ranked__header--ibd">
          <div className="ranked__image ranked__image--small">
            <Link to={`/innovation-by-design/${this.year}`}>
              <img
                src="https://images.fastcompany.net/image/upload/v1534893759/fcweb/ibd-2018-small_kg7ok2.jpg"
                alt=""
              />
            </Link>
          </div>
          <h1
            className={`ranked__ibd-title ${
              company ? 'ranked__ibd-title--black' : ''
            } ranked__icon ranked__icon--${data.url}`}
          >
            {data.category_name}
          </h1>
        </header>
      );
    }

    return (
      <header className="ranked__header ranked__header--ibd">
        <div className="ranked__image">
          <img
            src="https://images.fastcompany.net/image/upload/v1534893759/fcweb/idb-2018_l7ukwj.jpg"
            alt=""
          />
          <p className="ranked-company__credit ranked-company__credit--active ranked-company__credit--right">
            Logo by <a href="https://www.nicholasslater.co/">Nicholas Slater</a>
          </p>
        </div>
        <p className="ranked__description">
          Fast Company’s Innovation By Design Awards celebrate trailblazing
          design in business. This year,{' '}
          <Link to="/90160155/meet-the-jury-of-the-2018-innovation-by-design-awards">
            our expert judges
          </Link>{' '}
          selected standouts from more than 2,800 submissions across 16
          categories. That includes our first-ever Design Company of the Year
          Award, recognizing high-quality, ambitious design work throughout an
          organization. All the honorees share one thing:{' '}
          <Link to="/90227465/this-years-innovation-by-design-honorees-point-toward-empowerment-and-inclusivity">
            a commitment to solving problems
          </Link>, no matter how big or small, as simply and as beautifully as
          possible. See the 17 winners below, which represent the best of the
          best, and click the categories to see all 397 honorees. We hope you
          find them as inspiring as we do.
        </p>
      </header>
    );
  }

  renderPastWinners() {
    return (
      <div className="ranked__past-winners">
        <p>
          See past winners: <Link to="/innovation-by-design/2017">2017</Link> |{' '}
          <Link to="/innovation-by-design/2016">2016</Link> |{' '}
          <Link to="/innovation-by-design/2015">2015</Link> |{' '}
          <Link to="/innovation-by-design/2014">2014</Link> |{' '}
          <Link to="/innovation-by-design/2013">2013</Link> |{' '}
          <Link to="/innovation-by-design/2012">2012</Link>
        </p>
      </div>
    );
  }

  renderGroupHeader(data, secondary = '', black = false) {
    let categoryName = '';
    let url;
    let modifier = '';
    if (typeof data === 'string') {
      categoryName = data;
      modifier = categoryName.toLowerCase().replace(' ', '-');
    } else {
      categoryName = data.category_name;
      url = `/innovation-by-design/${this.year}/category/${data.url}`;
      modifier = data.url;
    }
    const markup = (
      <h2
        className={`ranked__group-title ${
          black ? 'ranked__icon--black ranked__group-title--black' : ''
        } ranked__icon ranked__icon--${modifier}`}
      >
        {categoryName}
        {secondary && ':'}
        {secondary && <span>{secondary}</span>}
      </h2>
    );

    return url ? <Link to={url}>{markup}</Link> : markup;
  }

  renderWinners(category) {
    return (
      <div>
        {this.getRankData(category.products, 'winners').map((product, idx) => (
          <div>
            {idx === 0 && this.renderGroupHeader(category)}
            <RankedCompany {...product} titleBefore={idx === 0} />
          </div>
        ))}
      </div>
    );
  }

  renderCategoryAndCompany(category, company = false) {
    const winners = this.getRankData(category.products, 'winners');
    const finalists = this.getRankData(category.products, 'finalists');
    const mentions = this.getRankData(category.products, 'mentions');
    return (
      <div>
        {winners.map((product, idx) => (
          <div>
            {(idx === 0 || company) &&
              this.renderGroupHeader('Winner', product.category_name, true)}
            <RankedCompany {...product} titleBefore={idx === 0} />
          </div>
        ))}
        {get(winners, 'length', 0) > 0 && <AdContainer type="break" />}
        {finalists.map((product, idx) => (
          <div>
            {(idx === 0 || company) &&
              this.renderGroupHeader('Finalist', product.category_name, true)}
            <RankedCompany {...product} titleBefore={idx === 0} />
          </div>
        ))}
        {get(finalists, 'length', 0) > 0 && <AdContainer type="break" />}
        {mentions.map((product, idx) => (
          <div>
            {(idx === 0 || company) &&
              this.renderGroupHeader(
                'Honorable Mention',
                product.category_name,
                true
              )}
            <RankedCompany {...product} titleBefore={idx === 0} />
          </div>
        ))}
        {get(mentions, 'length', 0) > 0 && <AdContainer type="break" />}
      </div>
    );
  }

  renderContent() {
    const { category, company } = get(this.props, 'match.params', {});
    const mobileAdEvery = 5;
    const param = category || company;
    let data = company
      ? this.getFilteredCompanies(company)
      : this.getCategories(param);

    return (
      <UserConsumer>
        {({ hasPaywallAccess }) => {
          const showDrawer = !hasPaywallAccess();
          if (showDrawer) {
            data = [...data].slice(0, 1);
          }
          return (
            <div className={clsx('ranked__main', showDrawer && 'main-locked')}>
              {data.map((cat, index) => (
                <div>
                  {!index && this.renderHeader(cat)}
                  {/* eslint-disable */}
                    {!param &&
                      mobileAdEvery % index === 0 && (
                        <AdContainer type="break" />
                    )}
                    {param
                      ? this.renderCategoryAndCompany(cat, company)
                      : this.renderWinners(cat)}
                    {index === data.length - 1 && this.renderPastWinners()}
                  </div>
                ))}
              {showDrawer && <PremiumPaywall />}
            </div>
          );
        }}
      </UserConsumer>
    );
  }

  renderSideBar() {
    const adCount = 2;
    return (
      <div className="ranked__sidebar ranked__sidebar--grouped">
        {[...Array(adCount)].map((blank, index) => (
          <div id={`ranked-sidebar-${index}`}>
            <Sticky
              top={100}
              bottomBoundary={`#ranked-sidebar-${index}`}
              enabled={this.isDesktop}
            >
              <AdContainer type="rail_sticky" />
            </Sticky>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { config, innovationByDesignPage, status } = this.props;

    if (innovationByDesignPage.error || status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }
    if (innovationByDesignPage.isLoading) {
      return (
        <section className="innovation-by-design-page">
          <article className="innovation-by-design-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    if (canUseDOM) {
      this.isDesktop = matchMediaDesktop();
    }

    return (
      <section
        className={`ranked__page ranked__page--${this.year} ranked__page--ibd`}
      >
        <AdContainer type="outstream" />
        <div className="ad-container post__article-top-ad-wrapper">
          <AdContainer type="break" />
        </div>
        <div className="ranked__wrapper">
          <div className="ranked__nav" id="ranked-nav">
            {this.renderNav()}
          </div>
          <div className="ranked__content">
            <div className="ranked__group">
              {this.renderContent()}
              {this.renderSideBar()}
            </div>
          </div>
        </div>
        <AllFeed
          stories={get(this.props, 'innovationByDesignAllFeed.posts')}
          allRendered={get(this.props, 'innovationByDesignAllFeed.allRendered')}
          config={config}
          titleOverride="All Stories In Innovation By Design"
        />
        {!this.isDesktop && (
          <RankedIBDMenu
            menu={[
              {
                title: 'All Winners',
                list: this.getAllWinners()
              },
              {
                title: 'Categories',
                list: this.getCategories()
              }
            ]}
            social={{
              uri: '',
              text: ''
            }}
          />
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  const ibdData = get(state, 'innovationByDesign.data.rows');
  const ibdYearDetail = get(
    state,
    'innovationByDesignDetail.data.rows[0].body'
  );

  return {
    config: state.config || {},
    status: state.status.code,
    innovationByDesignPage: get(state, 'innovationByDesignPage') || {
      error: true
    },
    innovationByDesign: ibdData || [],
    innovationByDesignYearDetail: ibdYearDetail || '',
    innovationByDesignAllFeed: {
      totalPosts: get(state, 'innovationByDesignAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'innovationByDesignAllFeed.data.totalPages', 0),
      allRendered: get(
        state,
        'innovationByDesignAllFeed.data.allRendered',
        false
      ),
      posts: get(state, 'innovationByDesignAllFeed.data.posts', [])
    }
  };
}

InnovationByDesign.defaultProps = {
  status: 200
};

InnovationByDesign.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  match: PropTypes.shape({}).isRequired,
  innovationByDesignPage: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  innovationByDesign: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  innovationByDesignAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired,
  innovationByDesignYearDetail: PropTypes.string.isRequired
};

export default withRouter(connect(mapStateToProps)(InnovationByDesign));
